module.exports = __webpack_public_path__ + "static/join-team-2-569d51dddf3df15b2ebd91d75fff74df.jpg";